import { render, staticRenderFns } from "./PaidActionError.vue?vue&type=template&id=40a71c42&"
import script from "./PaidActionError.vue?vue&type=script&lang=ts&"
export * from "./PaidActionError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports